import { useState } from "react";
import { PageHeader, Section } from "@/components/site/PageChrome";
import { Heart, Zap, Users, TrendingUp, Check, MapPin, Briefcase } from "lucide-react";

const culture = [
  { icon: Zap, t: "Move fast, stay local", d: "We ship quickly and stay close to the communities we serve." },
  { icon: Heart, t: "Ownership & care", d: "Everyone owns outcomes and cares deeply about the user experience." },
  { icon: Users, t: "Small team, big impact", d: "Lean teams, real responsibility, and room to grow." },
  { icon: TrendingUp, t: "Learn & grow", d: "Continuous learning is part of the job — we invest in our people." },
];

const openings = [
  { role: "Frontend Engineer (React)", type: "Full-time", loc: "Remote / India", tags: ["React", "Tailwind"] },
  { role: "Backend Engineer (Python)", type: "Full-time", loc: "Remote / India", tags: ["FastAPI", "MongoDB"] },
  { role: "City Growth Manager", type: "Full-time", loc: "On-site", tags: ["Growth", "Ops"] },
  { role: "Product Design Intern", type: "Internship", loc: "Remote", tags: ["UI/UX", "Figma"] },
  { role: "Community & Ambassador Lead", type: "Full-time", loc: "Hybrid", tags: ["Community"] },
];

export default function CareersPage() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", role: "", link: "" });
  const onSubmit = (e) => { e.preventDefault(); setSubmitted(true); };
  return (
    <>
      <PageHeader
        eyebrow="Careers"
        title="Build local, for millions."
        subtitle="Join a team making everyday city life easier across India. We're small, fast, and mission-driven."
      />

      <Section>
        <h2 className="text-3xl md:text-4xl font-bold text-[#1A1918]">Life at DIGISWING.</h2>
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {culture.map(({ icon: Icon, t, d }) => (
            <div key={t} className="rounded-3xl border border-[#EBE8E3] bg-white p-6">
              <Icon className="w-6 h-6 text-[#FF5A00]" />
              <h3 className="mt-3 font-bold text-[#1A1918]">{t}</h3>
              <p className="mt-2 text-sm text-[#4A4846]">{d}</p>
            </div>
          ))}
        </div>
      </Section>

      {/* <Section className="bg-[#FFF9F5]">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1A1918]">Open roles.</h2>
        <div className="mt-8 space-y-4">
          {openings.map((o) => (
            <div key={o.role} className="rounded-3xl border border-[#EBE8E3] bg-white p-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
              <div>
                <h3 className="text-lg font-bold text-[#1A1918]">{o.role}</h3>
                <div className="mt-1 flex flex-wrap items-center gap-3 text-sm text-[#78716C]">
                  <span className="inline-flex items-center gap-1"><Briefcase className="w-4 h-4" /> {o.type}</span>
                  <span className="inline-flex items-center gap-1"><MapPin className="w-4 h-4" /> {o.loc}</span>
                  {o.tags.map((t) => <span key={t} className="rounded-full bg-[#FFF3ED] text-[#FF5A00] px-2.5 py-0.5 text-xs font-semibold">{t}</span>)}
                </div>
              </div>
              <a href="#apply" className="rounded-full bg-[#FF5A00] hover:bg-[#E65100] text-white px-6 py-2.5 font-semibold text-sm text-center transition-colors">Apply</a>
            </div>
          ))}
        </div>
      </Section>

      <Section id="apply">
        <div className="max-w-xl mx-auto rounded-3xl border border-[#EBE8E3] bg-white p-8">
          <h2 className="text-2xl font-bold text-[#1A1918]">Submit your application</h2>
          <p className="text-sm text-[#78716C] mt-1">Don&apos;t see a fit? Send us your resume anyway — we love meeting great people.</p>
          {!submitted ? (
            <form onSubmit={onSubmit} data-testid="careers-form" className="mt-6 space-y-4">
              <input required data-testid="careers-name" placeholder="Full name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full rounded-xl border border-[#EBE8E3] bg-[#FDFBF7] px-4 py-3 text-sm outline-none focus:border-[#FF5A00]" />
              <input required type="email" data-testid="careers-email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full rounded-xl border border-[#EBE8E3] bg-[#FDFBF7] px-4 py-3 text-sm outline-none focus:border-[#FF5A00]" />
              <input required data-testid="careers-role" placeholder="Role you're applying for" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} className="w-full rounded-xl border border-[#EBE8E3] bg-[#FDFBF7] px-4 py-3 text-sm outline-none focus:border-[#FF5A00]" />
              <input required type="url" data-testid="careers-link" placeholder="Resume / portfolio link" value={form.link} onChange={(e) => setForm({ ...form, link: e.target.value })} className="w-full rounded-xl border border-[#EBE8E3] bg-[#FDFBF7] px-4 py-3 text-sm outline-none focus:border-[#FF5A00]" />
              <button type="submit" data-testid="careers-submit" className="w-full rounded-full bg-[#FF5A00] hover:bg-[#E65100] text-white py-3.5 font-semibold transition-colors">Submit Application</button>
            </form>
          ) : (
            <div data-testid="careers-success" className="text-center py-8">
              <div className="w-16 h-16 rounded-full bg-emerald-100 mx-auto flex items-center justify-center"><Check className="w-8 h-8 text-emerald-600" /></div>
              <h3 className="mt-4 text-xl font-bold text-[#1A1918]">Application received!</h3>
              <p className="mt-2 text-[#4A4846]">Thanks for applying. If there's a match, our team will reach out.</p>
            </div>
          )}
        </div>
      </Section> */}

      <Section className="bg-[#FFF9F5]">
  <h2 className="text-3xl md:text-4xl font-bold text-[#1A1918]">
    Career Opportunities
  </h2>

  {/* Current Openings
  <div className="mt-8 space-y-4">
    {openings.map((o) => (
      ...
    ))}
  </div>
  */}

  <div className="mt-8 max-w-3xl mx-auto">
    <div className="rounded-3xl border border-[#EBE8E3] bg-white p-10 text-center shadow-sm">
      <div className="w-20 h-20 mx-auto rounded-full bg-[#FFF3ED] flex items-center justify-center">
        <Briefcase className="w-10 h-10 text-[#FF5A00]" />
      </div>

      <h3 className="mt-6 text-3xl font-bold text-[#1A1918]">
        No Vacancies Currently
      </h3>

      <p className="mt-4 text-[#4A4846] max-w-xl mx-auto leading-relaxed">
        We don't have any active job openings at the moment.
        As Time2Cash expands to more cities, new career opportunities
        will be announced here. Stay connected and check back soon.
      </p>

      <div className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#FFF3ED] px-5 py-2 text-[#FF5A00] font-semibold">
        🚀 Hiring Opens Soon
      </div>
    </div>
  </div>
</Section>
    </>
  );
}
